/**
 * Companies allowed to see Risk Overview (iframe embed).
 * `company.id` from GET /core/v1/auth/user (`auth.store` → `companyData.id`).
 */
export const RISK_OVERVIEW_ALLOWED_COMPANY_IDS = Object.freeze([
  '69cea88151b6de0b98b0c112',
  '68cd8249cc2d2b91a341a708',
])

export function isRiskOverviewAllowedForCompany(companyId) {
  return Boolean(
    companyId && RISK_OVERVIEW_ALLOWED_COMPANY_IDS.includes(companyId),
  )
}
